import { Component, OnInit } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService';
import { ActivatedRoute, Router } from '@angular/router';
import { sessionStorage } from 'src/app/localstorage.service';
import { DialogComponent } from 'src/app/dialog.component';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UploadFileModalComponent } from 'src/app/upload-file-modal/upload-file-modal.component';
import { ImageModuleComponent } from '../image-module/image-module.component';

@Component({
    selector: 'app-payment-listing',
    templateUrl: './payment-listing.component.html',
    styleUrls: ['./payment-listing.component.scss']
})
export class PaymentListingComponent implements OnInit {

    active_tab = 'active';
    excelLoader: boolean = false;
    datanotfound: boolean = false;
    payment_list: any = [];
    count: any;
    total_page: any;
    sr_no: any = 0;
    pageCount: any;
    page_limit: any;
    pagenumber: any = 1;
    start: any = 0;
    exp_loader: any = false;
    loader: any = false;
    type: any;
    type_id: any;
    filter: any = {};
    login_data: any = [];
    login_dr_id: any;
    today_date: Date;
    assign_login_data2: any = [];
    fabBtnValue: any = 'add';
    assign_login_data: any = [];
    currentMonth_no: any;
    currentYear: any;
    currentMonth: any;
    monthNames: string[];
    OrderMonth: any;
    OrderYear: any;
    date: any;
    downurl: any = '';
    urls: any = [];
    image_url: any;
    lr_image_url: any;

    constructor(public serve: DatabaseService, public route: Router, public ActivatedRoute: ActivatedRoute,
        public dialog: DialogComponent, public session: sessionStorage, public alrt: MatDialog, public toast: ToastrManager, public dialogs: MatDialog) {
        this.downurl = serve.downloadUrl;
        this.page_limit = serve.pageLimit;
        this.today_date = new Date();
        this.assign_login_data = this.session.getSession();
        this.assign_login_data = this.assign_login_data.value;
        this.assign_login_data2 = this.assign_login_data.data;
        console.log(this.assign_login_data2, 'helllo');
        console.log(this.assign_login_data2.employee_id, 'idd');


        this.assign_login_data = this.assign_login_data.assignModule;
        this.date = new Date();
        this.monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        this.currentMonth = this.monthNames[this.date.getMonth()];
        this.currentYear = this.date.getFullYear();
        this.currentMonth_no = this.date.getMonth() + 1;
        this.image_url = serve.uploadUrl + 'checkin/'
        this.lr_image_url = serve.uploadUrl + 'lr_image/'

    }

    ngOnInit() {
        this.filter = this.serve.getData()
        this.login_data = this.session.getSession();
        this.login_data = this.login_data.value.data;
        if (this.login_data.access_level != '1') {
            this.login_dr_id = this.login_data.id;
        }

        this.ActivatedRoute.params.subscribe(params => {
            this.type_id = params.id;
            this.type = params.type;
            this.paymentData('', this.currentMonth_no, this.currentYear);
        });

    }

    goToImage(image) {
        const dialogRef = this.dialogs.open(ImageModuleComponent, {
            panelClass: 'Image-modal',
            data: {
                'image': image,
                'type': 'base64'
            }
        });
        dialogRef.afterClosed().subscribe(result => {

        });

    }

    ngOnDestroy() {
        this.serve.setData(this.filter)
    }

    // date_format(event, month, year): void {

    //     this.filter.date_created = moment(event.value).format('YYYY-MM-DD');
    //     this.paymentData('', month, year);
    // }

    calenderInfo: any = []
    paymentData(action: any = '', month, year) {
        if (action == "refresh") {
            this.filter = {};
            this.payment_list = [];
            this.start = 0;
        }
        if (this.pagenumber > this.total_page) {
            this.pagenumber = this.total_page;
            this.start = this.pageCount - this.page_limit;
        }
        if(this.filter.date_created){
            this.filter.date_created = moment(this.filter.date_created).format('YYYY-MM-DD');
        }

        if (this.start < 0) {
            this.start = 0;
        }
        this.OrderMonth = month
        this.OrderYear = year
        this.loader = true;
        console.log(this.filter.date_created, 'date')
        this.serve.post_rqst({ 'filter': this.filter, 'start': this.start, 'pagelimit': this.page_limit, }, "Account/transactionListing")
            .subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.payment_list = (result['result']);
                    this.calenderInfo = (result['calenderInfo']);
                    if (this.payment_list.length == 0) {
                        this.datanotfound = true
                    } else {
                        this.datanotfound = false

                    }
                    this.pageCount = result['count'];
                    if (this.pagenumber > this.total_page) {
                        this.pagenumber = this.total_page;
                        this.start = this.pageCount - this.page_limit;
                    }
                    else {
                        this.pagenumber = Math.ceil(this.start / this.page_limit) + 1;
                    }
                    this.total_page = Math.ceil(this.pageCount / this.page_limit);
                    this.sr_no = this.pagenumber - 1;
                    this.sr_no = this.sr_no * this.page_limit;
                    this.loader = false;
                } else {
                    this.loader = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }))
    }


    upload_excel() {
        const dialogRef = this.alrt.open(UploadFileModalComponent, {
            width: '500px',
            panelClass: 'cs-modal',
            data: {
                'from': 'Payment',
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.paymentData('', this.OrderMonth, this.OrderYear);
        });
    }


    refresh(blnk, month, year) {
        this.filter = {}
        this.serve.setData(this.filter)
        this.serve.currentUserID = ''
        this.paymentData(blnk, month, year);
    }

    id: any;
    state: any;
    tothepage(id, state, type) {
        this.route.navigate(['/distribution-detail/' + id], { queryParams: { state, id, type } });
    }


    exportAsXLSX(month, year) {
        this.loader = true;
        this.serve.post_rqst({ 'filter': this.filter, 'start': this.start, 'pagelimit': this.page_limit, 'month': month, 'year': year }, "Excel/invoice_payment_listing")
            .subscribe((result => {
                if (result['msg'] == true) {
                    this.loader = false;
                    window.open(this.downurl + result['filename'])
                    this.paymentData('', month, year);
                } else {
                }

            }));
    }

    lastBtnValue(value) {
        this.fabBtnValue = value;
    }
}
